<template>
  <div class="tw-flex tw-bg-header" v-if="!mobile">
    <div class="tw-flex-1" v-bind:style="logo"></div>
    <div class="tw-flex-1 tw-text-center tw-my-auto tw-text-white">
      {{raceName}}
    </div>
    <div class="tw-flex-1 tw-my-auto tw-text-white tw-mr-4 tw-text-center tw-py-2 timer">
      <div class="flex">
        <div class="tw-text-xs tw-font-body">{{raceTime | setRaceTime(race)}}</div>
        <div class="tw-font-heading tw-text-lg">{{time[race.id]}}</div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="tw-h-full tw-flex tw-bg-header tw-text-white tw-w-full">
      <div class="tw-flex-1" v-bind:style="logo">
      </div>
      <div class="tw-flex-1 tw-mr-2 text-right">
        {{raceName}}<br>
        {{time[race.id]}}
      </div>
    </div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex'
  import sponsors from './sponsors'
  import moment from 'moment'

  require('moment-timezone')

  export default {
    data() {
      return {
        dropdown: false,
        time: {},
        raceTime: 'START TIME',
        timezone: moment.tz(moment.tz.guess()).format('z'),
        interval: null
      }
    },
    filters: {
      setRaceTime: function (value, race) {
        let currentTime = moment().valueOf()
        let startTime = moment(race.start_at).valueOf()
        let active = race.active
        if (currentTime < startTime) {
          return 'START TIME'
        } else if (parseInt(active) >= 2) {
          return 'RACE TIME'
        } else if (currentTime >= startTime) {
          return 'RACE TIME'
        }
      }
    },
    components: {
      sponsors
    },
    mounted() {
      this.interval = setInterval(this.updateDateTime, 1000)
    },
    beforeDestroy() {
      clearInterval(this.interval)
    },
    computed: {
      ...mapGetters({
        mobile: 'mobile',
        races: 'races',
        sponsors: 'sponsors',
        focusedRace: 'focusedRace',
        starttime: 'starttime',
        event: 'event',
        race: 'race'
      }),
      logo: function () {
        if (this.event) {
          return {
            background: 'url(' + this.event.logo + ')' + 'center center / contain no-repeat',
            backgroundSize: 'contain'
          }
        }
        return ''
      },
      sponsorMaxWidth: function () {
        let w = 100 / this.sponsors.length
        return {
          maxWidth: w + '%',
          padding: '2px',
          maxHeight: '60px'
        }
      },
      raceName: function () {
        if (this.race) {
          return this.race.name
        }
      },
      name: function () {
        if (this.races.length > 0) {
          return this.races[0].name
        }
        return ''
      },
      dropdownDisplay: function () {
        let s = (this.dropdown ? 'block' : 'none')
        return {
          display: s
        }
      }
    },
    methods: {
      updateDateTime() {
        for (let race in this.event.races) {
          let currentTime = moment().valueOf()
          let startTime = moment.utc(this.event.races[race].start_at).local().valueOf()
          let value = parseInt(moment().unix() - moment.utc(this.event.races[race].start_at).local().unix())
          let active = this.event.races[race].active
          if (currentTime < startTime) {
            this.$set(this.time, this.event.races[race].id, moment.utc(this.event.races[race].start_at).local().format('Do MMM HH:mm') + ' ' + this.timezone)
          } else if (this.event.races[race].finished_at !== null) {
            this.$set(this.time, this.event.races[race].id, 'COMPLETED')
          } else if (currentTime >= startTime) {
            let dur = moment.duration(value, 'seconds')
            this.$set(this.time, this.event.races[race].id, Math.floor(dur.asHours()) + ':' + ((dur.minutes() < 10) ? '0' + dur.minutes() : dur.minutes()) + ':' + ((dur.seconds() < 10) ? '0' + dur.seconds() : dur.seconds()))
          }
        }
      },
      toggleRace: function (raceId) {
        this.$store.dispatch('loadRace', raceId)
        this.$ma.trackEvent({category: 'Click', action: 'Toggle race header', label: 'Loaded', value: ''})
        if (this.mobile) {
          this.$router.push({name: 'mleaderboard', params: {raceId: raceId}})
        } else {
          this.$router.push({name: 'leaderboard', params: {raceId: raceId}})
        }
        this.dropdown = false
      },
      sponsorUrlParse: function (url) {
        return url + '?h=60'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/header.vue